import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IController, IModule, IOnChangesObject, IPromise} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";

const css = require('./endringshendelser.scss');

    export class EndringshendelserKontroller implements IController {

        static registrerKomponent(angular: IModule) {
            angular
                .component('wkEndringshendelser', {
                    bindings: {
                        //enten hendelser eller hendelseslaster settes
                        hendelser: '<',
                        hendelseslaster: '&'
                    },
                    controller: EndringshendelserKontroller.forInjisering(),
                    template: require('./endringshendelser.html'),
                    transclude: true
                });
        }

        static forInjisering() {
            return [
                regNavn.ng.$attrs,
                EndringshendelserKontroller
            ]
        }

        constructor(private $attr: IAttributes) {
        }

        hendelserGruppert: { dato: Date; hendelser: l.EndringshendelseModell[] }[] = []; //settes via bindings/$onChanges
        hendelseslaster: (arg: { offset: number; antall: number }) => IPromise<l.SøkeresultatModell<l.EndringshendelseModell>>; //settes via bindings

        totaltAntall: number;
        offset = 0;

        private sidestørrelse = 50; /** antall hendelser som lastes per side */

        erPaginert(){
            return !_.isNil(this.$attr.$attr['hendelseslaster']);
        }

        lastFlere() {
            this.lastHendelser();
        }

        _formatDok(hendelse: l.EndringshendelseModell) {
            return _.keys(hendelse.beskrivelse.noeklerOgVerdier.beskrivelse).join(', ');
        }

        $onChanges(changes: IOnChangesObject) {
            this.hendelserGruppert = [];
            if (changes['hendelser'].currentValue)
                this.grupperOgLeggTil(changes['hendelser'].currentValue);
            else if (this.erPaginert())
                this.lastHendelser();
        }

        // hjelpemetoder

        private grupperOgLeggTil(hendelser: l.EndringshendelseModell[]) {
            //groupBy grupperer som streng - gjør derfor dato om til streng for senere å konvertere tilbake til dato
            _(hendelser)
                .groupBy(hendelse => moment(hendelse.utfoertDato).startOf('day').toDate().toISOString())
                .forIn((hendelser: l.EndringshendelseModell[], utfoertDato) =>
                    this.hendelserGruppert.push({
                        dato: moment(utfoertDato).toDate(),
                        hendelser: hendelser
                    }));
        }

        private lastHendelser() {
            this.hendelseslaster({offset: this.offset, antall: this.sidestørrelse})
                .then(resultat => {
                    this.grupperOgLeggTil(resultat.treff);
                    this.offset = this.offset + resultat.treff.length;
                    this.totaltAntall = resultat.totalantall;
                });
        }
    }
